import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlaces } from '../store/slices/placeSlice';

export const usePlaces = (branchId) => {
  const dispatch = useDispatch();
  const [places, setPlaces] = useState([]);
  const { loading } = useSelector((state) => state.place);

  const refetchPlaces = useCallback(() => {
    if (!branchId) {
      setPlaces([]);
      return;
    }

    dispatch(fetchPlaces(branchId)).unwrap()
      .then((data) => {
        setPlaces(data?.items || data || []);
      })
      .catch(() => {
        setPlaces([]);
      });
  }, [dispatch, branchId]);

  useEffect(() => {
    refetchPlaces();
  }, [refetchPlaces]);

  return {
    places,
    loading,
    refetchPlaces
  };
};

/**
 * Tüm şubeler (branş filtresi olmadan).
 *
 * Kapsam seçim ekranı il -> ilçe -> branş sırasıyla daralttığı için branş
 * seçilmeden önce de bütün şubelerin elde olması gerekiyor.
 */
export const useAllPlaces = () => {
  const dispatch = useDispatch();
  const [places, setPlaces] = useState([]);
  const { loading } = useSelector((state) => state.place);

  const refetchPlaces = useCallback(() => {
    dispatch(fetchPlaces(null)).unwrap()
      .then((data) => {
        setPlaces(data?.items || data || []);
      })
      .catch(() => {
        setPlaces([]);
      });
  }, [dispatch]);

  useEffect(() => {
    refetchPlaces();
  }, [refetchPlaces]);

  return {
    places,
    loading,
    refetchPlaces
  };
};
